import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../../../services/serviceCaller";
import { API_URL } from "../../../../../constants";
import Dynamic_PR_table from "../../../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../../constants/layout/store/filterSlice";

const PRCategory = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("PR Category Question Weightage Master"))
  }, [])
  const [searchTerm, setSearchTerm] = useState("");
  const [partnerMasterData, setPartnerMasterData] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = {
    SR: { text: "Sr.No.", align: "start", visible: false,width:'20px' ,visible: true },
    CategoryName: { text: "Category", align: "left", visible: true },
    QuestionName: { text: "Question", align: "start", visible: true },
    Mapping: { text: "KPI Mapping", align: "start", visible: true },
    // Weightage: { text: "Weightage", align: "start", visible: true },
  };

  useEffect(() => {
    fetchRomVendor();
  }, []);

  const handleView = (row) => {
    navigate(`/category-designation/view/${row.CategoryID}/${row.QuestionID}`);
  }
 

  const [apiStatus, setApiStatus] = useState(undefined)

  const fetchRomVendor = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(`${API_URL}get-listing-data`);
      setApiStatus(response?.status)
      if (response.status === 200) {
        const cleanedData = response?.data?.data;
        setPartnerMasterData(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partner Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Partner Master:", error);
    }
  };

const handleEdit = (row) => {
  console.log("row",row);
  const url = `/category-designation/add?categoryId=${row.CategoryID}&questionId=${row.QuestionID}`;
  window.open(url, "_blank");
};

//   const handleAddSubContractor = (id) => {
//     // navigate(`/contractors/add/${id.ID}`);
//         const url = `/category-designation/add/${id.ID}`;
//     window.open(url, '_blank'); // Opens in new tab
//   };

  const handleAddNewPartner = () => {
    navigate("/category-designation/add");

  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={partnerMasterData}
              columns={columns}
              itemsPerPage={8}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={true}
              isActionRequired={true}
              isSorting={true}
              isAddNewBtnRequired={true}
              showIcon3={false}
              showIcon4={true}
              showIcon5={false}
              handleIcon1={handleEdit}
              handleIcon2={handleView}
              handleAddNew={handleAddNewPartner}
            //   handleIcon4={handleAddSubContractor}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square  icons"></i>,
                Icon2Text:"Edit",
                Icon2: <i className="bi bi-eye-fill"></i>,
                Icon2Text: "View",
              }}
            />
          </div>
        </div>

      </div>
    </>
  );
};

export default PRCategory;
